import React from 'react';

import ConnectionSearchInput from 'instruments/connections/ConnectionSearchInput';
import {MultiValueFilter, Operator} from 'search/SearchConstants';

import {BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import {ItemSearchMultiValueFilterForm} from './ItemSearchFilterForm';

interface ConnectionFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onEnter?: () => void;
  onRemove?: () => void;
  operators: Array<Operator>;
}

export default function ConnectionFilterForm(props: ConnectionFilterFormProps): JSX.Element {
  return (
    <ItemSearchMultiValueFilterForm
      {...props}
      itemSearchInputClass={ConnectionSearchInput}
      itemSearchInputExtraProps={{shouldAllowMultiple: true}}
    />
  );
}
